export default function CTAForm() {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5517992623414';
    const message = encodeURIComponent('Olá! Gostaria de solicitar um diagnóstico estratégico gratuito.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <section id="cta-form" className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-3xl mx-auto text-center">
        <div className="mb-8 sm:mb-10 md:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Avalie a maturidade do seu marketing
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-10">
            Agende um diagnóstico estratégico gratuito e entenda onde estão os gargalos e oportunidades reais do seu crescimento.
          </p>
        </div>

        <button
          onClick={handleWhatsAppClick}
          className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-semibold hover:bg-[#20BA5A] transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-2xl sm:text-3xl"></i>
          Falar no WhatsApp
        </button>

        <p className="text-xs sm:text-sm text-gray-500 mt-6 sm:mt-8">
          Resposta rápida • Atendimento personalizado
        </p>
      </div>
    </section>
  );
}
